import { Component, useContext } from 'react'
import { debounce } from 'lodash-es'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import { CartContext, LineItemContext, QuantityContext } from './CartContext'
import AddToWishlistLink from '../AddToWishlistLink'
import QuantityField from './QuantityField'

class LineItem extends Component {
  static propTypes = {
    lineItem: PropTypes.object.isRequired,
    lineItemIndex: PropTypes.number.isRequired,
    renderItem: PropTypes.func.isRequired,
  }

  static contextType = CartContext

  getQuantity = () => {
    const cart = this.context
    const { lineItem } = this.props

    return cart.getQuantity(lineItem)
  }

  setQuantity = (quantity, quantityDelta) => {
    const cart = this.context
    const { lineItem } = this.props

    return cart.setQuantity(lineItem, quantity, quantityDelta)
  }

  render() {
    return (
      <LineItemContext.Provider value={this.props.lineItem}>
        <QuantityContext.Provider value={this}>
          {this.props.renderItem(this.props.lineItem, this.props.lineItemIndex)}
        </QuantityContext.Provider>
      </LineItemContext.Provider>
    )
  }
}

function RemoveLineItemButton(props) {
  const lineItem = useContext(LineItemContext)
  const cartContext = useContext(CartContext)

  return (
    <button
      {...props}
      type="button"
      onClick={() => {
        cartContext.removeLineItem(lineItem)
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }}
    />
  )
}

function CartQuantityField({ ...props }) {
  const lineItem = useContext(LineItemContext)
  const quantity = useSelector((state) =>
    state.getIn(['view', 'cart', 'quantities', lineItem.lineItemId], lineItem.quantity),
  )
  return <QuantityField {...{ ...props, quantity, lineItem }} />
}

function AddToWishlistLinkInCart({ ...props }) {
  const lineItem = useContext(LineItemContext)
  const cart = useContext(CartContext)
  const allProps = {
    ...props,
    callAfterItemAddedToWishlist: debounce(() => cart.setQuantity(lineItem, 0)),
    productId: lineItem.productId,
    quantity: lineItem.quantity,
    lineItemId: lineItem.lineItemId,
    customizedText: lineItem.customizedText,
    isCustomizableProduct: Boolean(lineItem.customizedHeadlineText && lineItem.customizedText),
    isInWishlist: lineItem.isInWishlist,
  }
  return <AddToWishlistLink {...allProps} />
}

export default Object.assign(LineItem, {
  RemoveLineItemButton,
  QuantityField: CartQuantityField,
  AddToWishlistLinkInCart,
})
